export default __webpack_public_path__ + "static/creditline-f07139482b966eda0668b2abe5334108.png";